import React from "react";
import { Button } from "@mui/material";
import { styled } from '@mui/material/styles';
import styles from "./button.module.css";

const VisuallyHiddenInput = styled('input')({
    clip: 'rect(0 0 0 0)',
    clipPath: 'inset(50%)',
    height: 1,
    overflow: 'hidden',
    position: 'absolute',
    bottom: 0,
    left: 0,
    whiteSpace: 'nowrap',
    width: 1,
});

const CustomButton = ({ icon, label, count, type, disabled = false, onClick = () => { }, }) => {
    // Handle file upload
    const handleFileUpload = (file) => {
        if (!file) return;
        onClick(file); // Call the onClick handler passed as prop
    };

    return (
        type !== "file_upload" ?
            <Button disabled={disabled} className={`${styles.customButton} ${styles[type]} ${disabled ? styles.disabled : ""} `} onClick={onClick} >
                {icon && <img src={icon} alt="filter" />}
                {label} {count !== undefined && `(${count})`}
            </Button>
            :
            <Button
                component="label"
                role={undefined}
                variant="contained"
                tabIndex={-1}
                startIcon={<img src={icon} alt="upload icon" className={styles.upload_img} />}
                className={`${styles.customButton} ${styles[type]}`}
                disabled={disabled}
                style={{cursor : disabled ? 'not-allowed' : 'pointer' }}
            >
                Upload
                <VisuallyHiddenInput
                    type="file"
                    accept=".xlsx, .xls"
                    onChange={handleFileUpload}
                    disabled={disabled}
                />
            </Button>
    )
}

export default CustomButton;
